export default {
  'imm0008.whereDoYouPlanToLive': 'Where do you plan to live in Canada?',
  'imm0008.provinceTerritory': 'Province/Territory',
  'imm0008.cityTown': 'City/Town',
  'imm0008.fullName': 'Full name',

  'imm0008.otherNames':
    'Have you ever used any other name (e.g. nickname, maiden name, alias, etc.)?',
  'imm0008.yesUsedOtherName': 'If yes, please provide the name you used',

  'imm0008.physicalCharacteristics': 'Physical characteristics',
  'imm0008.sex': 'Sex',
  'imm0008.eyeColour': 'Eye colour',
  'imm0008.height': 'Height (in cm)',

  'imm0008.birthInformation': 'Birth information',
  'imm0008.dateOfBirth': 'Date of birth (YYYY/MM/DD)',
  'imm0008.cityOfBirth': 'City of Birth',
  'imm0008.countryOfBirth': 'Country of Birth',

  'imm0008.citizenship': 'Citizenship(s)',
  'imm0008.citizenship1': 'First Citizenship',
  'imm0008.citizenship2': 'Second Citizenship (if applicable)',

  'imm0008.currentCountryOfResidence': 'Current country of residence',
  'imm0008.currentResidenceCountry': 'Country',
  'imm0008.currentResidenceStatus':
    'Residence status (e.g. citizen, permanent resident, worker, student, visitor, etc.)',
  'imm0008.currentResidenceVisaIssueDate':
    'Visa issue date (YYYY/MM/DD) (if applicable)',
  'imm0008.currentResidenceVisaExpiryDate':
    'Visa expiry date (YYYY/MM/DD) (if applicable)',

  'imm0008.lastEntryToCanada':
    'If your current country of residence is Canada, please provide the date and place of your last entry to Canada',
  'imm0008.lastEntryDate': 'Date (YYYY/MM/DD)',
  'imm0008.lastEntryPlace': 'Place',

  'imm0008.previousCountriesResidence': 'Previous countries of residence',
  'imm0008.hasPreviousCountries':
    'During the past five years, have you lived in any country other than your country of citizenship or your current country of residence (indicated above) for more than six months?',

  'imm0008.previousCountriesTitle':
    "If you answered 'yes' to the previous question, please provide details.",
  'imm0008.previousCountryTitle': 'Previous country of residence #',
  'imm0008.previousCountryCountry': 'Country',
  'imm0008.previousCountryImmigrationStatus':
    'Immigration status (e.g. citizen, permanent resident, worker, student, visitor, etc.)',
  'imm0008.previousCountryImmigrationStartDate':
    'Start date of immigration status (YYYY/MM/DD)',
  'imm0008.previousCountryImmigrationEndDate':
    'End date of immigration status (YYYY/MM/DD)',

  'imm0008.maritalStatusTitle': 'Marital and relationship status',
  'imm0008.currentMaritalStatus':
    'Current marital status (e.g. married, common-law, single, divorced, widowed, etc.)',
  'imm0008.marriageOrCommonLawDate':
    '(If you are married or in a common-law relationship) Provide the date on which you were married or entered into the common-law relationship. Date (YYYY/MM/DD)',
  'imm0008.fullNameOfSpouse':
    'Full name of your current/spouse/common-law partner (if applicable)',

  'imm0008.previousMarriageOrCommonLawTitle':
    'Previous marriage or common-law relationship',
  'imm0008.previouslyMarriedOrCommonLaw':
    'Have you previously been married or in a common-law relationship?',
  'imm0008.previousSpouseDetailsTitle':
    'If yes, please provide the details for your previous spouse/common-law partner',
  'imm0008.previousSpouseFullName':
    'Full name of your previous spouse/common-law partner',
  'imm0008.previousSpouseDob':
    'Date of birth of your previous spouse/common-law partner (YYYY/MM/DD)',
  'imm0008.typeOfRelationship': 'Type of relationship (Married or Common-Law)',
  'imm0008.relationshipStartDate': 'Start date of relationship (YYYY/MM/DD)',
  'imm0008.relationshipEndDate': 'End date of relationship (YYYY/MM/DD)',

  'imm0008.passportNumber':
    'Passport/travel document number (exactly as shown on your passport or travel document)',
  'imm0008.passportCountry':
    'Country of issue / Country Code (exact as shown on your passport or travel document)',
  'imm0008.passportIssueDate': 'Issue date (YYYY/MM/DD)',
  'imm0008.passportExpiryDate': 'Expiry date (YYYY/MM/DD)',

  'imm0008.nationalIdDocumentNumber': 'National identity document number',
  'imm0008.nationalIdCountry': 'Country of issue / Country Code',
  'imm0008.nationalIdIssueDate': 'Issue date (YYYY/MM/DD)',
  'imm0008.nationalIdExpiryDate': 'Expiry date (YYYY/MM/DD)',

  'imm0008.educationInfoTitle': 'Education information',
  'imm0008.highestEducation': 'Highest level of education',
  'imm0008.educationYears': 'Number of years of education in total',
  'imm0008.occupationInfoTitle': 'Occupation information',
  'imm0008.currentOccupation':
    'Current occupation (If your dependant doesn\'t work, enter "not employed.")',
  'imm0008.intendedOccupation':
    'Intended occupation (If your dependant isn\'t planning to work in Canada (for example, if they are younger than working age), enter "none.")',

  'imm0008.communicateInEnglishFrench':
    'Are you able to communicate in English and/or French? (Please select English or French or both or neither)',
  'imm0008.takenLanguageTest':
    'Have you taken a test to assess your English or French skills?',

  'imm0008.dependantTableTitle': 'Dependants',
  'imm0008.dependantTableFullName': 'Full name',
  'imm0008.dependantTableDob': 'Date of birth (YYYY/MM/DD)',
  'imm0008.dependantTableStatus': 'Status',
  'imm0008.dependantTableStatus.missingInformation': 'Missing Information',
  'imm0008.dependantTableStatus.complete': 'Complete',

  'imm0008.dependant.title': 'Dependant',
  'imm0008.dependant.description':
    'You must provide the following details about each of your family members, whether they will be accompanying you to Canada or not. You must include your spouse or common-law partner, if applicable, and all of your dependent children, and those of your spouse or common-law partner, who are not already permanent residents or citizens of Canada.',
  'imm0008.personalTitle': 'Personal Details',
  'imm0008.dependant.willAccompany':
    'Will this dependant accompany the principal applicant to Canada?',
  'imm0008.dependant.relationshipToPrincipalApplicant':
    'Relationship to principal applicant (e.g. spouse, common-law partner, child)',

  // 'imm0008.ifNotChina': 'If not China, please fulfill below:',
  // 'imm0008.fromDate': 'From (YYYY/MM/DD)',
  // 'imm0008.toDate': 'To (YYYY/MM/DD)',
  // 'imm0008.idFromDate': 'From (YYYY/MM/DD)',
  // 'imm0008.idToDate': 'To (YYYY/MM/DD)',

  'imm0008.steps.app': 'Application Details',
  'imm0008.steps.personal': 'Personal Details',
  //'imm0008.steps.contact': 'Contact Information',
  'imm0008.steps.passport': 'Passport',
  'imm0008.steps.id': 'National Identity Document',
  'imm0008.steps.career': 'Education/Occupation Details',
  'imm0008.steps.language': 'Language Details',
  'imm0008.steps.dependant': 'Dependants',
};
